import React from "react";
import { useNavigate } from "react-router-dom";

export default function ResultScreen({ isCleared, levelProgress, score, startGame }) {
    const navigate = useNavigate();

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-8 shadow-2xl text-center max-w-md w-full relative m-4">
                {/* Cleared message */}
                {isCleared && (levelProgress?.find(p => p.game === "ligningsmester" && p.level === 1)?.clears || 0) > 2 ? (
                    <>
                        <h2 className="text-2xl font-nunito font-semibold mb-4">sådan!</h2>
                        <span>værsgo, det har du fortjent 👏</span>
                        <img
                            src="/images/badges/ligningsmester_level1.png"
                            alt="Ligningsmester_1 Badge"
                            className="w-40 h-40 rounded-lg object-contain mx-auto mt-4"
                        />
                    </>
                ) : isCleared ? (
                    <>
                        <h2 className="text-2xl font-nunito font-semibold mb-4">godt gået!</h2>
                        <span> gør det {3 - (levelProgress?.find(p => p.game === "ligningsmester" && p.level === 1)?.clears || 0)} gange mere og du får et ligningsmester mærke, og er klar til næste level 👏</span>
                    </>
                ) : (
                    <>
                        <h2 className="text-2xl font-nunito font-semibold mb-4">💪 god træning!</h2>
                        <p className="mb-6 font-nunito font-light">du fik {score} point, hvilket kun er {150-score} fra målstregen - du er der næsten!</p>
                    </>
                )}

                {/* Buttons */}
                <div className="mt-12 mb-12">
                    <button
                        onClick={startGame}
                        className="bg-blue-500 w-2/5 mt-12 text-white px-4 py-2 rounded-xl hover:bg-blue-600 transition absolute bottom-4 right-4"
                        >
                        prøv igen
                    </button>
                    <button
                        onClick={() => navigate("/drills/ligningsmester")}
                        className="bg-blue-300 w-2/5 mt-12 text-white px-4 py-2 rounded-xl hover:bg-blue-600 transition absolute bottom-4 left-4"
                        >
                        hjem
                    </button>
                </div>
            </div>
        </div>
    );
}